import * as React from 'react'
import UIMessages from '../../../utils/ui-messages'
import HorizontalSelector from './HorizontalSelectorCustom'
import HorizontalSelectorItem from './HorizontalSelectorItemCustom'

export interface IRiderProfileCreateStepSelectorProps {
  path: string
  pathname: string
  isRiderSaved: boolean
  isStepComplete: (step: number) => boolean
}

const RiderProfileCreateStepSelector = ({
  path,
  pathname,
  isRiderSaved,
  isStepComplete
}: IRiderProfileCreateStepSelectorProps) => {
  const StepIcon = (props: { stepn: string; isSelected: boolean; isCompleted: boolean }) => {
    return (
      <div
        className='inline-block mr1'
        style={{
          width: '32px',
          height: '32px',
          lineHeight: '32px',
          borderRadius: '50%',
          textAlign: 'center',
          color: props.isCompleted ? 'white' : 'black',
          backgroundColor: props.isCompleted ? '#37C47E' : props.isSelected ? 'white' : 'transparent',
          border: '2px solid ' + (!props.isCompleted ? (props.isSelected ? '#37C47E' : '#979797') : '#37C47E')
        }}
      >
        {props.stepn}
      </div>
    )
  }

  return (
    <div className='bg-white'>
      <HorizontalSelector>
        <HorizontalSelectorItem isSelected={/\/info/.test(pathname)}>
          <StepIcon stepn='1' isCompleted={isStepComplete(1)} isSelected={/\/info/.test(pathname)} />
          <span className='font-small uppercase'>{UIMessages.common.profile}</span>
        </HorizontalSelectorItem>

        <HorizontalSelectorItem isSelected={/\/location/.test(pathname)}>
          <StepIcon stepn='2' isCompleted={isStepComplete(2)} isSelected={/\/location/.test(pathname)} />
          <span
            title={!isRiderSaved ? UIMessages.common.savePersonalInfoBeforeContinue : ''}
            className={(!isRiderSaved ? 'font-grey4 ' : '') + 'font-small uppercase'}
          >
            {UIMessages.rider.locations}
          </span>
        </HorizontalSelectorItem>

        <HorizontalSelectorItem isSelected={/\/membership/.test(pathname)}>
          <StepIcon stepn='3' isCompleted={isStepComplete(3)} isSelected={/\/membership/.test(pathname)} />
          <span
            title={!isRiderSaved ? UIMessages.common.savePersonalInfoBeforeContinue : ''}
            className={(!isRiderSaved ? 'font-grey4 ' : '') + 'font-small uppercase'}
          >
            {UIMessages.common.membership}
          </span>
        </HorizontalSelectorItem>

        <HorizontalSelectorItem isSelected={/\/wallet/.test(pathname)}>
          <StepIcon stepn='4' isCompleted={isStepComplete(4)} isSelected={/\/wallet/.test(pathname)} />
          <span
            title={!isRiderSaved ? UIMessages.common.savePersonalInfoBeforeContinue : ''}
            className={(!isRiderSaved ? 'font-grey4 ' : '') + 'font-small uppercase'}
          >
            {UIMessages.common.wallet}
          </span>
        </HorizontalSelectorItem>
      </HorizontalSelector>
    </div>
  )
}

export default RiderProfileCreateStepSelector



// WEBPACK FOOTER //
// ./src/components/riders/createrider/RiderProfileCreateStepSelector.tsx